export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_02.40ee8696.jpg";